import { $ui, loadingHandler, toast } from '@/utils/ui'
import { DEMANDES_STATUS } from '@/consts/data/demandes'
import { INDETERMINATE_STATUS, MODAL_EVENT_UPDATE_AGENT_REQUEST } from '@/consts/app'
import { ROUTE_NAME_PLATFORM_AGENT_REQUESTS } from '@/router/platform'
import { modalEmail } from '@/utils/ui/modal'
import { postAgencyAgentRequest } from '@/utils/api/agency/agent/request'
import store from '@/store'
import router from '@/router'

export const onStatusChange = (agentRequest = {}, status) =>
  new Promise((resolve) => {
    const { id, agent, content, subject } = agentRequest
    const a = store.getters['user/agency/getAgent'](agent.slug)
    if (!a) {
      return toast.negative('Agent introuvable')
    }
    const statusInfos = DEMANDES_STATUS[status] || INDETERMINATE_STATUS
    const { href } = router.resolve({
      name: ROUTE_NAME_PLATFORM_AGENT_REQUESTS,
      params: {
        id
      }
    })
    modalEmail({
      to: [a.email],
      subject: `[${statusInfos.label}] Mise à jour de votre demande "${subject}"`,
      message: `Bonjour,<br/><br/>
                  Le statut de votre demande "${subject}" est à présent "${statusInfos.label}".<br/><br/>
                  Cordialement.<br/><br/><hr/><br/>
                  <i><u>Contenu original de la demande :</u></i><br/>
                  ${content}<br/>
                  <a href="${process.env.APP.app.front}/${href}">Voir la demande sur ${process.env.APP.name}</a>`
    }, { auto: true })
      .then((modal) => modal.on('submit', () => loadingHandler(async () => {
        $ui.$emit(
          MODAL_EVENT_UPDATE_AGENT_REQUEST,
          [
            await postAgencyAgentRequest({
              ...agentRequest,
              status
            })
          ]
        )
        resolve()
      })))
  })
